import { CategoryType } from "../CategoryType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const categoryTypeNameMap: Record<CategoryType, LocalizedString> = {
	[CategoryType.Accessory]: {
		[Locale.cs]: "Příslušenství",
		[Locale.en]: "Accessory",
	},
	[CategoryType.Coffee]: {
		[Locale.cs]: "Káva",
		[Locale.en]: "Coffee",
	},
	[CategoryType.Merch]: {
		[Locale.cs]: "Merch",
		[Locale.en]: "Merch",
	},
};
